import React from 'react'
import { useHistory } from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form'
import { size } from 'lodash'
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Link,
  Typography,
} from '@material-ui/core'

import { AttachmentTable, JoditEditor } from 'components'

import helpers from 'helpers'

import useSnackbar from 'hooks/useSnackbar'

import schema from './schema'
import { routes } from 'Routes'
import useStyles from './styles'
import * as service from 'service'
import constants from 'constants/index'
import theme from 'theme'

const ReplyTicket = ({
  refresh = () => {},
  setLoading = () => {},
  ticketId,
}) => {
  const history = useHistory()
  const classes = useStyles()
  const snackbar = useSnackbar()
  const { control, handleSubmit, reset, errors, watch, setValue } = useForm({
    validationSchema: schema,
    defaultValues: {
      content: '',
      attachments: null,
    },
  })

  const { EXTERNAL_KIND_ID } = constants.ticketMessages

  const { filterAccepted, handleRemove } = helpers.file

  const attachments = watch('attachments')

  const onSubmit = async (data) => {
    try {
      setLoading(true)

      await service.dponet.tickets.createMessage({
        ticketId: ticketId,
        kind: EXTERNAL_KIND_ID,
        ...data,
      })
      snackbar.open({
        message: 'Mensagem enviadas com sucesso!',
        variant: 'success',
      })
      refresh()
      reset()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(
            error?.response?.data?.error,
            false,
          ) ||
          'O sistema de tickets está indisponível no momento. Você pode entrar em contato através do e-mail atendimento@dponet.com.br',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} id="reply-ticket-form">
      <Box
        display="flex"
        flexDirection="column"
        gridGap={theme.spacing(2)}
        pt={2}
      >
        <Controller
          control={control}
          name="content"
          as={
            <JoditEditor.Editor
              error={!!errors?.content}
              helperText={errors?.content?.message}
            />
          }
          mode="onBlur"
        />
        <Controller
          control={control}
          name="attachments"
          as={
            <FormControl>
              <Typography variant="body1">
                Para anexar arquivos,&nbsp;
                <Link
                  href="#"
                  htmlFor="input-file"
                  component="label"
                  className={classes.link}
                >
                  Clique aqui.
                </Link>
              </Typography>
              <Typography variant="caption">
                Arquivos suportados: {constants.validations.ALL_FILE_TYPES}
              </Typography>
              <input
                multiple
                type="file"
                id="input-file"
                accept={constants.validations.ALL_FILE_TYPES}
                className={classes.inputFile}
              />
            </FormControl>
          }
          onChange={([event]) => filterAccepted(event, attachments)}
        />
        {!!errors.attachments && (
          <FormHelperText error={!!errors?.attachments}>
            {errors?.attachments?.message}
          </FormHelperText>
        )}
        {size(attachments) > 0 && (
          <AttachmentTable
            openWrite
            attachments={helpers.file.toArray(attachments)}
            handleDelete={(index) =>
              handleRemove({ attachments, index, setValue })
            }
          />
        )}
        <Box
          display="flex"
          justifyContent="end"
          alignContent="center"
          gridGap={theme.spacing(1)}
        >
          <Button
            variant="contained"
            onClick={() => history.push(routes.technicalFaqs.tickets.all)}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            form="reply-ticket-form"
          >
            Enviar
          </Button>
        </Box>
      </Box>
    </form>
  )
}

export default ReplyTicket
